import { ChartCompanyInvoiceStatusSummaryItem } from './ChartCompanyInvoiceStatusSummaryItem';

export class ChartCompanyInvoiceStatusSummary{
    public pending : ChartCompanyInvoiceStatusSummaryItem;
    public payed : ChartCompanyInvoiceStatusSummaryItem;
    public lateBill : ChartCompanyInvoiceStatusSummaryItem;
}